import { render, staticRenderFns } from "./OrganizationSelector.vue?vue&type=template&id=c3dfadde&scoped=true"
import script from "./OrganizationSelector.vue?vue&type=script&lang=ts"
export * from "./OrganizationSelector.vue?vue&type=script&lang=ts"
import style0 from "./OrganizationSelector.vue?vue&type=style&index=0&id=c3dfadde&prod&lang=scss"
import style1 from "./OrganizationSelector.vue?vue&type=style&index=1&id=c3dfadde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dfadde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})
